import React from 'react';
import { Container, Row } from 'reactstrap';
import SizingCard from './SizingCard';
import StatusIndicatorCard from './StatusIndicatorCard';
import ShapeCard from './ShapeCard';
import InitialsCard from './InitialsCard';
import GroupCard from './GroupCard';
import { Breadcrumbs } from '../../../AbstractElements';
import Ratiocard from './Ratiocard';

const AvatarsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Avatars' parent='Ui Kits' title='Avatars' />
      <div className='user-profile'>
        <Row>
          <SizingCard />
          <InitialsCard />
          <StatusIndicatorCard />
          <ShapeCard />
          <Ratiocard />
          <GroupCard />
        </Row>
      </div>
    </Container>
  );
};

export default AvatarsContainer;
